<template>
  <div
    v-if="site"
    class="z-video"
  >
    <div
      v-if="poster && showPoster"
      class="video-js vjs-default-skin vjs-paused vjs-fluid vjs_video_3-dimensions vjs-controls-enabled vjs-workinghover vjs-v7 vjs-user-active vjs-youtube"
      @click="togglePoster"
    >
      <div
        class="vjs-poster"
        role="img"
        :style="{
          backgroundImage: `url(${poster})`
        }"
      ></div>

      <button
        class="vjs-big-play-button"
        type="button"
        title="Play Video"
        aria-disabled="false"
      >
        <span
          class="vjs-icon-placeholder"
          aria-hidden="true"
        ></span>
        <span
          class="vjs-control-text"
          aria-live="polite"
        >
            Play Video
        </span>
      </button>
    </div>

    <iframe
      v-else
      class="z-video__iframe"
      :src="siteSrc"
      v-bind="iframeAttributes"
    />
  </div>

  <div v-else>
    <p>Invalid URL</p>
  </div>
</template>

<script>
import { sites } from './sites'

export default {
    name: 'video-iframe',
    props: {
        poster: {
            type: String
        },
        src: {
            type: [String, Array],
            required: true
        },
        iframeAttrs: {
            type: Object
        }
    },
    data () {
        return {
            showPoster: true
        }
    },
    computed: {
        site () {
            return sites.find(e => new URL(this.src).host.includes(e.name))
        },
        iframeAttributes () {
            if (typeof this.iframeAttrs === 'object') return this.iframeAttrs
            else if (typeof this.site === 'object') return this.site.iframe.defaultAttributes
            else return {}
        },
        siteSrc () {
            if (typeof this.site === 'object') {
                return this.site.srcModificate(this.site.getSrc(this.src), {
                    actualAttributes: this.iframeAttributes
                })
            } else return ''
        }
    },
    methods: {
        togglePoster () {
            this.showPoster = !this.showPoster
        }
    }
}
</script>

<style lang="scss">
.z-video {
    display: flex;

    &__iframe {
        background-color: $token-colors-gray-10;
        width: 100%;
        aspect-ratio: 16/9;
    }
}
</style>
